import * as React from 'react';
import { ProductInterface } from '../../../Model/Product';
import { AbstractRow } from '../AbstractRow';
import { AttributeCell } from '../AttributeCell';
import { FinderImage } from '../FinderImage';
import { HeadlineCell } from '../HeadlineCell';
import { MiscCell } from '../MiscCell';
import { WatchlistCell } from '../WatchlistCell';

export class MeasuringRollerRow extends AbstractRow {
    public renderCells() {
        const product = this.props.product;

        return <>
            <td><FinderImage product={product} attr="Produktgruppenbild"/></td>
            <AttributeCell product={product} attr="Produktgruppenbeschreibung_kurz"/>
            <AttributeCell product={product} attr="Kundennutzen"/>
            <AttributeCell product={product} extra={true} attr="Foerderbandart"/>
            <AttributeCell product={product} extra={true} attr="eichfaehig" title="Eichfähig"/>
            <AttributeCell product={product} extra={true} attr="Temperaturbereich"/>
            <AttributeCell product={product} extra={true} attr="Temperaturkoeffizient"/>
            <AttributeCell product={product} extra={true} attr="Schutzart"/>
            <AttributeCell product={product} extra={true} attr="ueberlastsicherung" title="Überlastsicherung"/>
            <MiscCell product={product}
                      datasheetAttr='Datenblatt'
                      manualAttr='Bedienungsanleitung'
                      installationInstructionAttr='Montageanweisung'
                      installationInstructionTitle='Montageanweisung'
            />
        </>;
    }

    protected renderHeadline(product: ProductInterface): JSX.Element {
        return <>
            <HeadlineCell colSpan={3} product={product} attr="name"/>
            <WatchlistCell product={product}/>
        </>;
    }
}
